import React from 'react'

interface ContainerProps {
	className?: string
	style?: React.CSSProperties
	mode?: 'row' | 'col'
}

interface ItemProps {
	style?: React.CSSProperties
}

export default class AppLayout extends React.Component<ContainerProps> {
	static RowFix: React.FC<React.CSSProperties> = props => {
		return (
			<div className="app-layout-row-fix" style={props}>
				{props.children}
			</div>
		)
	}

	static ColFix: React.FC<ItemProps> = props => {
		return (
			<div className="app-layout-column-fix" style={props.style}>
				{props.children}
			</div>
		)
	}

	render() {
		let mode = this.props.mode || 'row'
		if (mode === 'row')
			return (
				<div className={`app-layout-row ${this.props.className || ''}`} style={this.props.style}>
					{this.props.children}
				</div>
			)
		else
			return (
				<div className={`app-layout-column ${this.props.className || ''}`} style={this.props.style}>
					{this.props.children}
				</div>
			)
	}
}



// WEBPACK FOOTER //
// ./src/components/AppLayout/index.tsx